import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DirectAddService } from '@app/modules/direct/services/direct-add.service';
import { DirectSiteContentService } from '@app/modules/direct/services/direct-content.service';
import { DeviceDetectionService } from '@app/shared/services/device-detection/device-detection.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'sbnb-direct-add-assets',
  styleUrls: ['direct-add-assets.component.scss'],
  templateUrl: './direct-add-assets.component.html',
})
export class DirectAddAssetsComponent implements OnInit, OnDestroy {
  iframeSrc: SafeResourceUrl;
  destroy$ = new Subject<void>();

  isMobile$ = this.deviceDetectionService.isMobileViewport();

  constructor(
    public directAddService: DirectAddService,
    public directSiteContentService: DirectSiteContentService,
    private sanitizer: DomSanitizer,
    private deviceDetectionService: DeviceDetectionService
  ) {}

  ngOnInit() {
    this.directSiteContentService.refreshIframe$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.directAddService.site.preview_url);
    });

    this.directSiteContentService.init(this.directAddService.site.id);
  }

  ngOnDestroy() {
    this.directSiteContentService.destroy(this.directAddService.site.id);
    this.destroy$.next();
  }

  continue() {
    if (this.directSiteContentService.loading) return;
    this.directAddService.nextStep();
  }
}
